import piaApi from "../../../api/dtl/pia";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // 提交定制信息
  submitInfo({ state }, { params, callback }) {
    console.log(state);
    piaApi.submitInfoApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dtl/pia.js